import React from 'react';
import Moment from 'moment';

import { DropdownCalendarLoader } from '../utilities/formComponents';
import DocumentDelegate from '../utilities/DocumentDelegate';
import ReactDropDownCalender from './ReactDropDownCalender';

import '../styles/componentStyle/globalHeader/date-selector-panel.scss';

export class DateSelectorPanel extends React.Component {
  constructor(props) {
    super(props);

    const {
      show,
      positionKey,
      fromDate,
      toDate,
      workHourZone,
      workHourZoneDayVisible = true,
      workHourZoneNightVisible = true,
      workHourZoneMidnightVisible = true,
      onChangeSearchDateRange = () => {},
      showNextButtons = true,
    } = props;

    this.state = {
      positionKey,
      show,
      workHourZoneDayVisible,
      workHourZoneNightVisible,
      workHourZoneMidnightVisible,
      fromDate,
      toDate,
      workHourZone,
      onChangeSearchDateRange,
      showNextButtons,
    };
    /**
     * カレンダーコントロール
     * fromDate
     * toDate
     * workHourZone   1:昼  2:夜  3:深夜
     */

    this.handleChangeDate = this.handleChangeDate.bind(this);
    this.handleClickWorkHourZone = this.handleClickWorkHourZone.bind(this);
  }

  componentDidMount() {
    DocumentDelegate.init();
    this.DropDownCalendar = new DropdownCalendarLoader();
    this.DropDownCalendar.init(DocumentDelegate, (element, name, value) => {
      this.setState({ [name]: value });
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.show !== this.props.show) {
      this.setState({
        show: this.props.show,
      });
    }

    if (prevState.fromDate !== this.state.fromDate) {
      const afterOneMonth = Moment(this.state.fromDate, 'YYYY/MM/DD')
        .add(1, 'month')
        .add(-1, 'days');
      if (Moment(this.state.toDate, 'YYYY/MM/DD').isAfter(afterOneMonth)) {
        this.setState({
          toDate: afterOneMonth.format('YYYY/MM/DD'),
        });
      }
    }
    if (prevState.toDate !== this.state.toDate) {
      const beforeOneMonth = Moment(this.state.toDate, 'YYYY/MM/DD')
        .subtract(1, 'month')
        .add(1, 'days');
      if (Moment(this.state.fromDate, 'YYYY/MM/DD').isBefore(beforeOneMonth)) {
        this.setState({
          fromDate: beforeOneMonth.format('YYYY/MM/DD'),
        });
      }
    }

    const {
      workHourZoneDayVisible,
      workHourZoneNightVisible,
      workHourZoneMidnightVisible,
      fromDate,
      toDate,
      workHourZone,
    } = this.props;

    if (
      prevProps.workHourZoneDayVisible !== workHourZoneDayVisible ||
      prevProps.workHourZoneNightVisible !== workHourZoneNightVisible ||
      prevProps.workHourZoneMidnightVisible !== workHourZoneMidnightVisible ||
      prevProps.fromDate !== fromDate ||
      prevProps.toDate !== toDate ||
      prevProps.workHourZone != workHourZone
    ) {
      this.setState({
        workHourZoneDayVisible,
        workHourZoneNightVisible,
        workHourZoneMidnightVisible,
        fromDate,
        toDate,
        workHourZone,
      });
    }
  }

  /**
   * 期間 選択カレンダーコントロールの 前月 選択
   */
  handleSelectBeforeOneMonth = () => {
    const baseDate = Moment(this.state.fromDate, 'YYYY/MM/DD').add(
      -1,
      'months'
    );
    this.setState({
      fromDate: baseDate.startOf('month').format('YYYY/MM/DD'),
      toDate: baseDate.endOf('month').format('YYYY/MM/DD'),
    });
  };
  /**
   * 期間 選択カレンダーコントロールの 今月 選択
   */
  handleSelectThisMonth = () => {
    this.setState({
      fromDate: Moment()
        .startOf('month')
        .format('YYYY/MM/DD'),
      toDate: Moment()
        .endOf('month')
        .format('YYYY/MM/DD'),
    });
  };
  /**
   * 期間 選択カレンダーコントロールの 翌月 選択
   */
  handleSelectAfterOneMonth = () => {
    const baseDate = Moment(this.state.fromDate, 'YYYY/MM/DD').add(1, 'months');
    this.setState({
      fromDate: baseDate.startOf('month').format('YYYY/MM/DD'),
      toDate: baseDate.endOf('month').format('YYYY/MM/DD'),
    });
  };

  /**
   * 期間 選択カレンダーコントロールの 前週 選択
   */
  handleSelectBeforeOneWeek = () => {
    const baseDate = Moment(this.state.fromDate, 'YYYY/MM/DD').add(-1, 'week');
    this.setState({
      fromDate: baseDate.startOf('week').format('YYYY/MM/DD'),
      toDate: baseDate.endOf('week').format('YYYY/MM/DD'),
    });
  };
  /**
   * 期間 選択カレンダーコントロールの 今週 選択
   */
  handleSelectThisWeek = () => {
    this.setState({
      fromDate: Moment()
        .startOf('week')
        .format('YYYY/MM/DD'),
      toDate: Moment()
        .endOf('week')
        .format('YYYY/MM/DD'),
    });
  };
  /**
   * 期間 選択カレンダーコントロールの 翌週 選択
   */
  handleSelectAfterOneWeek = () => {
    const baseDate = Moment(this.state.fromDate, 'YYYY/MM/DD').add(1, 'week');
    this.setState({
      fromDate: baseDate.startOf('week').format('YYYY/MM/DD'),
      toDate: baseDate.endOf('week').format('YYYY/MM/DD'),
    });
  };

  /**
   * 日付 選択カレンダーコントロールの 前日 選択
   */
  handleSelectYesterday = () => {
    const baseDate = Moment(this.state.fromDate, 'YYYY/MM/DD').add(-1, 'days');
    this.setState({
      fromDate: baseDate.format('YYYY/MM/DD'),
      toDate: baseDate.format('YYYY/MM/DD'),
    });
  };
  /**
   * 日付 選択カレンダーコントロールの 今日 選択
   */
  handleSelectToday = () => {
    this.setState({
      fromDate: Moment().format('YYYY/MM/DD'),
      toDate: Moment().format('YYYY/MM/DD'),
    });
  };
  /**
   * 日付 選択カレンダーコントロールの 翌日 選択
   */
  handleSelectTomorrow = () => {
    const baseDate = Moment(this.state.fromDate, 'YYYY/MM/DD').add(1, 'days');
    this.setState({
      fromDate: baseDate.format('YYYY/MM/DD'),
      toDate: baseDate.format('YYYY/MM/DD'),
    });
  };

  handleChangeDate = (name, value) => {
    const dates = {
      fromDate: this.state.fromDate,
      toDate: this.state.toDate,
    };
    const target = { ...dates, [name]: value };
    if (
      Moment(target.toDate, 'YYYY/MM/DD').diff(
        Moment(target.fromDate, 'YYYY/MM/DD'),
        'day'
      ) < 0
    ) {
      return;
    }
    this.setState({ [name]: value });
  };

  /**
   * 昼 夜 深夜 チェックボックス クリック時のイベントハンドラ
   */
  handleClickWorkHourZone = workHourZone => {
    this.setState({ workHourZone });
  };

  render() {
    return this.state.show ? (
      <div className='date-selector-panel'>
        <div className='date-selector-panel__container'>
          <div className='date-selector-panel__row'>
            <ReactDropDownCalender
              onChange={date => this.handleChangeDate('fromDate', date)}
              value={this.state.fromDate}
              format={'YYYY/MM/DD(ddd)'}
            />
            <p className='date-selector-panel__date-separator'>〜</p>
            <ReactDropDownCalender
              onChange={date => this.handleChangeDate('toDate', date)}
              value={this.state.toDate}
              format={'YYYY/MM/DD(ddd)'}
            />
          </div>
          <div className='date-selector-panel__row'>
            <button
              className='date-selector-panel__button date-selector-panel__button--small date-selector-panel__button--previous'
              onClick={this.handleSelectYesterday}
            >
              前日
            </button>
            <button
              className='date-selector-panel__button'
              onClick={this.handleSelectToday}
            >
              今日
            </button>
            {this.state.showNextButtons && (
              <button
                className='date-selector-panel__button date-selector-panel__button--small date-selector-panel__button--next'
                onClick={this.handleSelectTomorrow}
              >
                翌日
              </button>
            )}
          </div>
          <div className='date-selector-panel__row'>
            <button
              className='date-selector-panel__button date-selector-panel__button--small date-selector-panel__button--previous'
              onClick={this.handleSelectBeforeOneWeek}
            >
              前週
            </button>
            <button
              className='date-selector-panel__button'
              onClick={this.handleSelectThisWeek}
            >
              今週
            </button>
            {this.state.showNextButtons && (
              <button
                className='date-selector-panel__button date-selector-panel__button--small date-selector-panel__button--next'
                onClick={this.handleSelectAfterOneWeek}
              >
                翌週
              </button>
            )}
          </div>
          <div className='date-selector-panel__row'>
            <button
              className='date-selector-panel__button date-selector-panel__button--small date-selector-panel__button--previous'
              onClick={this.handleSelectBeforeOneMonth}
            >
              前月
            </button>
            <button
              className='date-selector-panel__button'
              onClick={this.handleSelectThisMonth}
            >
              今月
            </button>
            {this.state.showNextButtons && (
              <button
                className='date-selector-panel__button date-selector-panel__button--small date-selector-panel__button--next'
                onClick={this.handleSelectAfterOneMonth}
              >
                翌月
              </button>
            )}
          </div>
          <div className='date-selector-panel__footer'>
            <button
              className='btn--contained btn--wide'
              onClick={() => {
                this.props.onChangeSearchDateRange({
                  fromDate: this.state.fromDate,
                  toDate: this.state.toDate,
                  workHourZone: this.state.workHourZone,
                });
              }}
            >
              変更
            </button>
          </div>
        </div>
      </div>
    ) : null;
  }
}



// WEBPACK FOOTER //
// ./src/components/DateSelectorPanel.jsx